import { FileXls } from '@phosphor-icons/react';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';

const ExportButton = ({ endpoint, filename, label = "Export Excel" }) => {
  const handleExport = async () => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/export/${endpoint}`,
        { credentials: 'include' }
      );
      
      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${filename}_${new Date().toISOString().split('T')[0]}.xlsx`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
        toast.success('Export Excel téléchargé');
      } else {
        toast.error('Erreur lors de l\'export');
      }
    } catch (error) {
      console.error('Export failed:', error);
      toast.error('Erreur lors de l\'export');
    }
  };

  return (
    <Button
      variant="outline"
      onClick={handleExport}
      className="border-[#334155] text-[#F8FAFC] hover:bg-[#1E293B]"
      data-testid={`export-${endpoint}-button`}
    >
      <FileXls size={18} className="mr-2 text-[#10B981]" weight="duotone" />
      {label}
    </Button>
  );
};

export default ExportButton;
